import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { UsersState } from './store/users/users.state';
import { ColorEnum } from './shared/enum/color.enum';
import { LoadingService } from './shared/service/loading.service';
import { User } from './store/users/users.model';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

  title = 'angular-compliance';
  connectedUser$: Observable<User> = inject(Store).select(UsersState.getConnectedUser);
  loadingRouterReq: boolean = false;
  loadingHttpReq: boolean = false;

  constructor(private loadingService: LoadingService) {
  }

  ngOnInit() {
    this.loadingService.routingLoader();

    this.loadingService.loadingRouterBehaviorSubject.subscribe((isLoadingRoute) => {
      this.loadingRouterReq = isLoadingRoute;
    })
    this.loadingService.loadingHttpRequestBehaviorSubject
      .subscribe((isLoadingHttpReq) => {
        this.loadingHttpReq = isLoadingHttpReq;
    })

    Object.keys(ColorEnum).forEach((key, index) => {
      let value = Object.values(ColorEnum)[index]
      document.body.style.setProperty(`--color_${key}`, value);
    })
  }
}
